import { LOCATION_TAB } from './constants';
import LocationMapping from './LocationMapping';
import DOWMapping from './DOWMapping';

export const createLocationMappingProps = ({
  mapId,
  terminalId,
  glEventHub,
  geoDataList,
  isDataLoaded,
  onDeleteLocation,
  equipmentSizeList,
  getLocationMappingData,
  isLocationDeleteInProgress,
  customerLocationMappingData
}) => ({
  mapId,
  terminalId,
  glEventHub,
  geoDataList,
  isDataLoaded,
  onDeleteLocation,
  equipmentSizeList,
  getLocationMappingData,
  isLocationDeleteInProgress,
  locationMappingData: customerLocationMappingData,
  isCustomerLocationFlow: true
});

export const createDowMappingProps = ({
  mapId,
  terminalId,
  glEventHub,
  dowGeoDataList,
  isDowDataLoaded,
  handleDeleteDowLocation,
  getDowLocationMappingData,
  dowLocationMappingData,
  isDowLocationDeleteInProgress,
  ...otherProps
}) => ({
  mapId,
  terminalId,
  glEventHub,
  geoDataList: dowGeoDataList,
  isDataLoaded: isDowDataLoaded,
  onDeleteLocation: handleDeleteDowLocation,
  getLocationMappingData: getDowLocationMappingData,
  locationMappingData: dowLocationMappingData,
  isLocationDeleteInProgress: isDowLocationDeleteInProgress,
  ...otherProps
});

export const createTabs = ({
  locationMappingProps,
  dowMappingProps,
  isDeliveryLocationMappingEnabled
}) => [
  {
    label: 'Equipment',
    id: LOCATION_TAB.EQUIPMENT,
    isEnabled: true,
    component: <LocationMapping {...locationMappingProps} />
  },
  {
    label: 'DOW Delivery',
    id: LOCATION_TAB.DOW_DELIVERY,
    isEnabled: isDeliveryLocationMappingEnabled,
    disabledTooltipText: 'Delivery location mapping is not enabled',
    component: <DOWMapping {...dowMappingProps} />
  }
];
